import * as React from 'react';

/**
 * During Backstop tests, applies `visibility: hidden` to children.
 */
export const BackstopInvisible = props => (
  <span title="This node is invisible to Backstop tests" className="backstop-ignore" {...props} />
);

/**
 * During Backstop tests, applies `display: none` to children.
 */
export const BackstopRemove = props => (
  <span title="This node is removed during Backstop tests" className="backstop-remove" {...props} />
);
